import { T2, TEXT_LENGTH } from '@nile/components';
import { Button, TextField } from '@superops/ui-design-system';
import { includes } from 'lodash';
import React, { useState } from 'react';
import styled from 'styled-components';

const TextFieldContainer = styled.div`
  input {
    height: 30px;
    border: none;
    border-bottom: 1px solid #ececec;
    margin-top: 0px !important;
    margin-bottom: 10px;
    outline: none;
    padding: 1px 2px;

    &::-webkit-input-placeholder {
      color: #000000;
      opacity: 0.4;
    }
    &:-ms-input-placeholder {
      color: #000000;
      opacity: 0.4;
    }
    &::placeholder {
      color: #000000;
      opacity: 0.4;
    }

    &:hover,
    &:focus {
      border-bottom: 1px solid #ececec;
    }
  }
  .Polaris-TextField__Backdrop {
    display: none;
  }
`;
function MultiNumericField(props) {
  const {
    placeholder,
    label,
    name,
    deleteButton,
    onItemAdded,
    onItemDeleted,
    className,
    labelClassName,
    charCodes,
    values: inputValues,
    shouldAddOnBlur,
    addHelper,
    handleValidation
  } = props;
  const [values, setValues] = useState(inputValues || []);
  const [value, setValue] = useState('');

  const handleItemAdd = (val) => {
    if (
      includes(values, val) ||
      !val ||
      (handleValidation && !handleValidation(val))
    ) {
      setValue(val);
      return;
    }
    const newValues = values.concat(value);
    setValues(newValues);
    setValue('');
    onItemAdded(value, newValues);
  };

  const handleItemRemove = (value) => {
    const newValues = values.filter((v) => v !== value);
    onItemDeleted(value, newValues);
    setValues(newValues);
  };

  const handleBlur = () => {
    if (shouldAddOnBlur) {
      !isNaN(value) && handleItemAdd(value);
    }
  };

  const handleValueChange = (value) => {
    setValue(value);
  };

  const handleKeypress = (e) => {
    if (includes(charCodes, e.charCode)) {
      e.preventDefault();
      !isNaN(value) && handleItemAdd(e.target.value);
    }
  };

  return (
    <div className="multiple-value-text-input">
      <T2>{label || ''}</T2>
      <ItemsHolder className="items-holder">
        {values.length > 0
          ? values.map((el) => {
              return (
                <Item>
                  <div>{el}</div>
                  <Delete
                    className="multi-text-delete"
                    tabIndex="-1"
                    role="button"
                    onKeyPress={() => handleItemRemove(el)}
                    onClick={() => handleItemRemove(el)}
                  >
                    {deleteButton}
                  </Delete>
                </Item>
              );
            })
          : ''}
      </ItemsHolder>
      <TextFieldContainer onKeyPress={handleKeypress}>
        <TextField
          name={name}
          value={value}
          placeholder={placeholder || 'Type number and press enter'}
          type="number"
          onChange={handleValueChange}
          onBlur={handleBlur}
          className={className}
          maxLength={TEXT_LENGTH.size_4}
        />
      </TextFieldContainer>
      {addHelper && (
        <Button
          onClick={() => {
            handleItemAdd(value);
          }}
          plain
        >
          Add
        </Button>
      )}
    </div>
  );
}

const ItemsHolder = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 10px;
  max-width: 300px;
`;

const Item = styled.div`
  display: flex;
  align-items: center;
  background: #ececec;
  border-radius: 5px;
  padding: 4px 8px;
  margin-right: 8px;
  margin-bottom: 8px;
`;

const Delete = styled.div`
  margin-left: 8px;
  cursor: pointer;
  outline: none;
`;

MultiNumericField.defaultProps = {
  placeholder: '',
  charCodes: [13],
  deleteButton: <span>&times;</span>,
  values: [],
  label: '',
  shouldAddOnBlur: true,
  className: '',
  labelClassName: ''
};

export default MultiNumericField;
